import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthenticationService } from '@sb-tools/typescript/authentication/authentication.service';

@Injectable()
export class RedirectGuard implements CanActivate {
    constructor(
        private router: Router,
        private authenticationService: AuthenticationService, // private appInsightsService: AppInsightsService
    ) {}

    canActivate(): boolean {
        const community = this.authenticationService.community;
        console.log('COMMUNITY: ' + community);
        if (community) {
            this.router.navigateByUrl('/' + community + '/user');
        } else {
            this.authenticationService.redirectToCommunities();
        }

        return false;
    }
}
